import { render, staticRenderFns } from "./RecoverForm.vue?vue&type=template&id=3c527a0a&scoped=true"
import script from "./RecoverForm.vue?vue&type=script&lang=js"
export * from "./RecoverForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverForm.vue?vue&type=style&index=0&id=3c527a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c527a0a",
  null
  
)

export default component.exports